<template>
    <a-list
        class="thread-list"
        :loading="loading"
        item-layout="horizontal"
        :data-source="data"
    >
        <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta>
                <span slot="title" class="thread-title">
                    <a :class="{ top: item.top > 0 }"
                        :href="`/bbs/thread/?tid=${item.id}&p=1`" target="_blank"
                    >{{ item.title }}</a>
                    <a-tag color="#2db7f5" v-if="item.top    > 0">置顶<a-icon type="pushpin"/></a-tag>
                    <a-tag color="#2db7f5" v-if="item.star   > 0">精品<a-icon type="star"   /></a-tag>
                    <a-tag color="#BDBDBD" v-if="item.locked > 0">锁定<a-icon type="lock"   /></a-tag>
                </span>
                <a-icon slot="avatar" type="unordered-list" style="color: orange;"/>
                <span slot="description">
                    <user-link :name="item.authorname" :id="item.author"/> 发表于{{ formatDate(item.posttime) }} |
                    <span v-if="item.lastreplyer">
                        <user-link :name="item.lastreplyername" :id="item.lastreplyer"/> 最后回复于{{ formatTime(item.lastreplytime) }}
                    </span>
                    <span v-else>
                        还没有回复
                    </span>
                </span>
            </a-list-item-meta>
            <div>
                <a-icon type="message"/>
                <span class="reply-count">{{ item.replycnt }}</span>
            </div>
        </a-list-item>
        <a-pagination :current="Number($route.params.page)" :total="total" 
            :defaultPageSize="20" @change="turnPage" :hideOnSinglePage="true"
        />
    </a-list>
</template>

<script>
import UserLink from '../../components/UserLink.vue';
import axios from '../../plugins/axios';
import { scrollToElm } from '../../utils/utils';

export default {
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.load(to.name, to.params.page);
        });
    },
    async beforeRouteUpdate(to, from, next) {
        await this.load(to.name, to.params.page);
        next();
    },
    data: () => ({
        data: [],
        total: 0,
        loading: false,
    }),
    methods: {
        async load(bid, page) {
            this.loading = true;
            scrollToElm(document.getElementById("app"));
            const { data } = await axios.get(`/backend/bbs/threadList.php`, {
                params: {
                    bid, page
                }
            });
            this.loading = false;
            this.data = data.list;
            this.total = data.total;
        },
        turnPage(page) {
            this.$router.push({ name: this.$route.name, params: { page } });
        },
        formatDate(timestamp) {
            return (new Date(timestamp * 1000)).toLocaleDateString("cn-ZH", { hour12: false });
        },
        formatTime(timestamp) {
            return (new Date(timestamp * 1000)).toLocaleString("cn-ZH", { hour12: false });
        }
    },
    components: {
        UserLink
    },
}
</script>

<style lang="less" scoped>
.ant-list-item-meta {
    text-align: left;
}
.ant-list-item-meta-title {
    font-size: 18px;
    line-height: 24px;
}
.reply-count {
    width: 30px;
    display: inline-block;
}
.thread-title {
    a {
        color: rgba(0, 0, 0, 0.65);
        &.top {
            color: red;
        }
    }
    .ant-tag {
        transform: translateY(-2px);
        margin-left: 5px;
    }
}
</style>